import React from 'react';
import EveRoutes from '../EveRoutes';

export interface EveGeneralErrorProps {
  product: string;
  contact: string;
}

const EveGeneralError = ({ product, contact }: EveGeneralErrorProps): JSX.Element => {
  return (
    <>
      <h2>Something went wrong.</h2>
      <p data-testid="general-error">
        {product} encountered a problem and is unable to complete your request at this time. Please wait a few minutes
        and try again or <a href={EveRoutes.HOME}>go to the homepage.</a> If the error persists, contact{' '}
        <a href={`mailto:${contact}`}>{contact}</a> and tell us exactly what you were doing when you received the error
        so we can get this resolved for you as soon as possible.
      </p>
    </>
  );
};

export default EveGeneralError;
